import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card } from '../ui/card';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { ArrowsClockwise, ListMagnifyingGlass, MagnifyingGlass } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ACTION_COLORS = {
  order_retried: 'bg-blue-500/15 text-blue-500 border-blue-500/30',
  order_cancelled: 'bg-red-500/15 text-red-500 border-red-500/30',
  user_updated: 'bg-purple-500/15 text-purple-500 border-purple-500/30',
  user_password_reset: 'bg-orange-500/15 text-orange-500 border-orange-500/30',
  user_deleted: 'bg-red-500/15 text-red-500 border-red-500/30',
  margin_updated: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/30',
  site_content_updated: 'bg-cyan-500/15 text-cyan-500 border-cyan-500/30',
  orders_exported: 'bg-indigo-500/15 text-indigo-500 border-indigo-500/30',
  orders_refreshed: 'bg-teal-500/15 text-teal-500 border-teal-500/30',
  backup_created: 'bg-amber-500/15 text-amber-500 border-amber-500/30',
};

export const LogsPanel = () => {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const p = new URLSearchParams();
      if (q) p.set('q', q);
      p.set('limit', '200');
      const { data } = await axios.get(`${API_URL}/api/admin/logs?${p.toString()}`, { withCredentials: true });
      setLogs(data.logs || []);
      setTotal(data.total || 0);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="space-y-4" data-testid="logs-panel">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <h2 className="text-2xl font-bold flex items-center gap-2">
            <ListMagnifyingGlass size={20} weight="duotone" className="text-primary" /> Logs de actividad
          </h2>
          <p className="text-sm text-muted-foreground">{total} registros en total</p>
        </div>
        <div className="flex gap-2">
          <div className="relative">
            <MagnifyingGlass size={14} className="absolute left-3 top-2.5 text-muted-foreground" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filtrar por admin / acción / target" className="pl-8 w-64" data-testid="logs-search" />
          </div>
          <Button size="sm" onClick={load} data-testid="logs-refresh">
            <ArrowsClockwise size={14} className={`mr-1.5 ${loading ? 'animate-spin' : ''}`} /> Buscar
          </Button>
        </div>
      </div>

      <Card className="border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/40 text-xs uppercase text-muted-foreground">
              <tr>
                <th className="text-left px-3 py-2">Fecha</th>
                <th className="text-left px-3 py-2">Admin</th>
                <th className="text-left px-3 py-2">Acción</th>
                <th className="text-left px-3 py-2">Target</th>
                <th className="text-left px-3 py-2">Detalles</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 && (
                <tr><td colSpan={5} className="text-center py-8 text-muted-foreground">Sin logs.</td></tr>
              )}
              {logs.map((l, i) => (
                <tr key={i} className="border-t border-border/60" data-testid={`log-row-${i}`}>
                  <td className="px-3 py-2 text-xs whitespace-nowrap font-mono">{l.ts?.slice(0, 19).replace('T', ' ')}</td>
                  <td className="px-3 py-2 text-xs">{l.admin_email || 'sistema'}</td>
                  <td className="px-3 py-2">
                    <Badge className={ACTION_COLORS[l.action] || 'bg-muted text-foreground'} variant="outline">{l.action}</Badge>
                  </td>
                  <td className="px-3 py-2 text-xs font-mono">{l.target || '—'}</td>
                  <td className="px-3 py-2 text-xs">
                    {l.meta && Object.keys(l.meta).length > 0 ? (
                      <pre className="text-[10px] font-mono text-muted-foreground max-w-md truncate">{JSON.stringify(l.meta)}</pre>
                    ) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};
